import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataObject } from '../../models/data-object.model';

@Injectable({
  providedIn: 'root',
})
export class SpLinkOpportunityService {
  private opportunityLinking: Subject<{ leaseToLink: number; record: DataObject }> = new Subject();
  public opportunityLinking$ = this.opportunityLinking.asObservable();
  public triggerOpportunity(leaseToLink: number, record: any) {
    this.opportunityLinking.next({ leaseToLink, record });
  }
}
